import React, { use } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const BookingSucessModal = ({ onClose, appointmentData, extraProps }) => {
  const {formData} = extraProps;
//   if (!appointmentData) return null;

const navigate = useNavigate();

console.log("extraProps", extraProps);
    const handleClick = () => {
        onClose();
        navigate('/doctors-grid')
    };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          maxWidth: 550,
          width: "100%",
          background: "#fff",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          fontFamily: "Arial, sans-serif",
          textAlign: "center",
          padding: "24px",
        }}
      >
        {/* ✅ Success Icon */}
        <FaCheckCircle size={60} color="#00b4aa" style={{ }} />

        {/* ✅ Title */}
        <h3 style={{ color: "#00b4aa", marginBottom: "0.5rem" }}>
          Your OPD appointment has been successfully booked <br /> with RB Diagnostic.
        </h3>

        {/* ✅ Appointment Details */}
        <p style={{ fontSize: "15px", color: "#333",  }}>
          The appointment ID is <b>{appointmentData}</b>, and the patient’s name is <b>{`${formData.FName} ${formData.LName}`}</b>.
           The appointment is scheduled for{" "}
          <b>{extraProps?.selectedDate} at {extraProps?.selectedTime}</b> at the{" "}
          <b>{extraProps?.selectedCenter?.center_name}</b> Branch, where you will be consulting{" "}
          <b>{extraProps?.doctor?.doctor_name}</b>. <br />
          The consultant fee for the appointment is{" "}
          <b style={{ color: "#00b4aa" }}>₹{extraProps?.selectedCenter?.Fees}/-</b>. <br />
          Please ensure to arrive on time and bring any necessary documents for the consultation.
        </p>

        {/* ✅ OK Button */}
        <button
          onClick={handleClick}
          style={{
            marginTop: "20px",
            backgroundColor: "#00b4aa",
            border: "none",
            borderRadius: "6px",
            padding: "12px 40px",
            color: "#fff",
            fontSize: "16px",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          Ok
        </button>
      </div>
    </div>
  );
};

export default BookingSucessModal;
